module.exports = __webpack_public_path__ + "img/square_bf.ee3aeb73.svg";